import { render } from "./LesDecrets.vue?vue&type=template&id=66f9f610&scoped=true"
const script = {}

import "./LesDecrets.vue?vue&type=style&index=0&id=66f9f610&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f9f610"]])

export default __exports__